export default __webpack_public_path__ + "static/media/Screenshot_B31.675d47f9.jpg";